<template>
  <div class="input_wrap-1">
    <InputMoneyVmodel
      v-if="FeeKey == 'đ'"
      v-model="arrayParent[0][valueKey]" 
      :max="max" 
      @change="$emit('change')"
      @input="$emit('input')"
      class="form-control input_wrap-1-input"
      >
    </InputMoneyVmodel>
    <InputMoneyVmodel 
      v-if="FeeKey == '%'"
      :isPercent="true"
      v-model="arrayParent[1][valueKey]"  
      :max="100" 
      :min="0"
      @change="$emit('change')"
      @input="$emit('input')"
      class="form-control input_wrap-1-input"
      >
    </InputMoneyVmodel>
    <el-button-group class="input_wrap-1-btn">
      <el-button @click="$emit('changeFeeKey',item.key)" v-for="(item, i) in arrayParent" :key="i" size="small" :type="item.key == FeeKey ? 'primary' : ''">{{ item.key }}</el-button>
    </el-button-group>
  </div>
</template>

<script>
import InputMoneyVmodel from './inputMoneyVmodel.vue'
export default {
  components: { InputMoneyVmodel },
  props: ["FeeKey","arrayParent","valueKey","max","min"]
  // methods: {
  // }
}
</script>

<style lang="scss">
.input_wrap-1 {
  position: relative;
  .input_wrap-1-input {
    padding-right: 44%;
  }
  .input_wrap-1-btn {
    position: absolute;
    right: 4%;
    top: 50%;
    transform: translate(0, -50%);
  }
}
</style>